import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const NicaraguaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15677'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15677)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#1A78D6'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#1A78D6'
				/>
				<path
					d='M10.0008 8.73331C10.9675 8.73331 11.7627 7.96359 11.7627 6.99998C11.7627 6.03637 10.9675 5.26664 10.0008 5.26664C9.03414 5.26664 8.23893 6.03637 8.23893 6.99998C8.23893 7.96359 9.03414 8.73331 10.0008 8.73331Z'
					stroke='#DBCD92'
					strokeWidth='0.666667'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99926 6.06665L10.9516 7.93332H9.04688L9.99926 6.06665Z'
					fill='#9CDDEE'
				/>
			</g>
		</svg>
	);
};

export default NicaraguaFlagIcon;
